export default __webpack_public_path__ + "a318f055054a7396d3158126eb73268a.jpg";